export class GeneratorType {
  id: string;
  name: string;
}
